module.exports = __webpack_public_path__ + "img/Scanvaegt2.68ee31da.png";